module.exports = __webpack_public_path__ + "img/audiovisuel.56d34fbd.jpg";